import { Header, PageHeader, Spacer } from "components";
import { useContext, FC } from "react";
import { SubscriptionContent } from "subscriptions/components/SubscriptionContent";
import { AppContext } from "config/appProvider";

export const SubscriptionDetails: FC = () => {
  const { mainAppState } = useContext(AppContext);
  return (
    <>
      <PageHeader>
        <Spacer baselineHeight={2} />
        <Header title="Subscription Details" backButton />
      </PageHeader>
      <SubscriptionContent currentBU={mainAppState.selectedBU} />
    </>
  );
};
